import config from "../config";

const currencyToLocale = {
  USD: 'en-US',
  IDR: 'id-ID',
  RP: 'id-ID',
  EUR: 'de-DE',
};

const currencyToFractionDigits = {
    USD: 2,
    IDR: 0,
    RP: 0,
    EUR: 2,
};

const formatOverrides = {
    USD: {
        unit: { minimumFractionDigits: 0, maximumFractionDigits: 0 },
        currency: { minimumFractionDigits: 2, maximumFractionDigits: 2 },
    },
    IDR: {
        unit: { minimumFractionDigits: 0, maximumFractionDigits: 0 },
        currency: { minimumFractionDigits: 0, maximumFractionDigits: 0 },
    },
    RP: {
        unit: { minimumFractionDigits: 0, maximumFractionDigits: 0 },
        currency: { minimumFractionDigits: 0, maximumFractionDigits: 0 },
    },
    EUR: {
        unit: { minimumFractionDigits: 0, maximumFractionDigits: 0 },
        currency: { minimumFractionDigits: 2, maximumFractionDigits: 2 },
    },
};

export const sanitizeNumberInput = (value) => {
    return value.replace(/[^0-9]/g, ''); // Remove all non-numeric characters
};

export const preventInvalidKeyInput = (e) => {
    if (
        ['e', 'E', '+', '-', '.'].includes(e.key) || // Disallow symbols
        e.key === 'ArrowDown' || // Prevent scroll down
        e.key === 'ArrowUp' // Prevent scroll up
    ) {
        e.preventDefault();
    }
};

export const restrictToDecimalNumbers = (e) => {
    const key = e.key;
    const value = e.target.value;
    const selectionStart = e.target.selectionStart;
    const selectionEnd = e.target.selectionEnd;

    if (
        e.key === 'Backspace' || 
        e.key === 'Delete' || 
        e.key === 'Tab' || 
        e.key === 'Escape' || 
        e.key.includes('Arrow') 
    ) {
        if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
             e.preventDefault();
        }
        return; 
    }

    if ((e.ctrlKey || e.metaKey) && ['a', 'c', 'v', 'x', 'z'].includes(key.toLowerCase())) {
        return; 
    }

    if (key.match(/[0-9]/)) {
        const dotIndex = value.indexOf('.');
        if (dotIndex !== -1 && selectionStart > dotIndex) {
            const decimals = value.substring(dotIndex + 1);
            if (decimals.length >= 2 && selectionStart === selectionEnd) {
                e.preventDefault();
            }
        }
        return;
    }

    if (key === '.') {
        if (value.includes('.') && selectionStart === selectionEnd) {
            e.preventDefault();
        }
        return;
    }
    
    e.preventDefault();
};

export const sanitizeDecimalInput  = (e) => {
    let val = e.target.value;

    val = val.replace(/[^0-9.]/g, '');

    const firstDot = val.indexOf('.');
    if (firstDot !== -1) {
        val = val.substring(0, firstDot + 1) + val.substring(firstDot + 1).replace(/\./g, '');
    }

    if (val.includes('.')) {
        const [intPart, decPart] = val.split('.');
        val = intPart + '.' + decPart.slice(0, 2);
    }

    e.target.value = val;
};

export const formatCurrency = ( value, type = "currency", currencyCode = config.CURRENCY_ISO_CODE || config.CURRENCY_SYMBOL ) => {
    const number = parseFloat(value);
    if (isNaN(number)) return "0";

    if (currencyToLocale[type] && currencyCode === (config.CURRENCY_ISO_CODE || config.CURRENCY_SYMBOL)) {
        currencyCode = type;
        type = "currency";
    }

    const locale = currencyToLocale[currencyCode] || "en-US";
    const override = formatOverrides[currencyCode]?.[type];
    const fractionDigits = override || {
        minimumFractionDigits: currencyToFractionDigits[currencyCode] ?? 2,
        maximumFractionDigits: currencyToFractionDigits[currencyCode] ?? 2,
    };

    return new Intl.NumberFormat(locale, {
        style: "decimal",
        ...fractionDigits,
    }).format(number);
};